<template>
    <form-view class="map-service-form-view" @submitsuccess="submitSuccess">
        <veui-steps :steps="steps" :current="1"/>
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :readonly="!!store.createForFixedAppId || isDetail"
                :disabled="isEdit"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
           <veui-field label="服务名称："
                name="name"
                field="name"
                :readonly="isDetail"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <veui-field label="所属行业：" name="secondLevelIndustry" field="secondLevelIndustry" rules="required" :disabled="isEdit">
                <veui-select
                    :options="store.industryDatasource"
                    :disabled="isEdit"
                    :readonly="isDetail"
                    v-model="store.formData.firstLevelIndustry"/>
                <veui-select
                    :options="secondLevelIndustryDatasource"
                    :disabled="isEdit"
                    :readonly="isDetail"
                    v-model="store.formData.secondLevelIndustry"/>
            </veui-field>
            <veui-field label="是否同步到地图："
                name="sync"
                field="sync"
                rules="required"
                :disabled="isEdit"
                :readonly="isDetail">
                <veui-radio-group :items="store.yesAndNo"
                    v-model="store.formData.sync"/>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button v-if="isDetail" @click="goToFieldDetail" ui="primary">查看门店字段</veui-button>
            <template v-else-if="isCreate">
                <veui-button ui="primary" type="submit" @click="operationType = 'saveNext'">保存并继续</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="operationType = 'saveDraft'">保存为草稿</veui-button>
            </template>
            <template v-else-if="isEditDraft">
                <veui-button ui="primary" type="submit" @click="operationType = 'publish'">提交发布</veui-button>
                <veui-button type="submit" @click="operationType = 'modifyStore'">修改门店数据</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="operationType = 'saveDraft'">保存为草稿</veui-button>
            </template>
            <veui-button v-else-if="isEdit" ui="primary" type="submit">修改完成</veui-button>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input, Span, Select, Dialog, Fieldset, RadioGroup} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import mapMixin from './mixin';
import {get, find} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'MapServiceFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-dialog': Dialog,
        'veui-select': Select,
        'veui-fieldset': Fieldset,
        'veui-radio-group': RadioGroup,
        SearchSelect
    },
    mixins: [serviceMixin, mapMixin],
    computed: {
        secondLevelIndustryDatasource() {
            let first = this.store.formData.firstLevelIndustry;
            if (first) {
                let second = get(find(this.store.industries, {name: first}), 'children') || [];
                return second.map(i => ({label: i.name, value: i.name}));
            }
            return [];
        }
    },
    data() {
        return {
            operationType: null,
            steps: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '上传门店信息'
                },
                {
                    label: '发布服务'
                }
            ]
        };
    },
    methods: {
        submitSuccess(result) {
            switch (this.operationType) {
                case 'saveNext':
                case 'modifyStore':
                    let pageType = this.store.pageType === 'create'
                        ? 'edit'
                        : this.store.pageType;
                    let prefix = this.store.isAdmin ? '' : '/app';
                    this.global.redirect({
                        url: `${prefix}/service/${result.serviceId}/map/store/${pageType}`,
                        type: 'push'
                    });
                    break;
                case 'publish':
                    this.store.requestPublish();
                    break;
                default:
                case 'saveDraft':
                    this.back();
                    break;
            }
        }
    }
});
</script>

<style lang="less">
.map-service-form-view {
    .veui-form-label {
        width: 130px;
    }
}
</style>
